import { validRegExp } from './util';
import {
	email,
	tel,
	num,
	int,
	date,
	money,
	mobile,
	url,
	url_root,
	hundred,
	hundredDecimal,
	character,
} from './reg';
import validId from './validIdCard';

const customValid = (func, msg = '请输入正确格式', reg = null, type = 'blur') => {
	let customFunc = (rule, value, callback) => {
		if (typeof callback === 'function') {
			if (!value || (value.length && value.length === 0)) {
				return callback();
			} else if (!func(value, reg)) {
				return callback(new Error(msg));
			} else {
				return callback();
			}
		} else {
			if (func(callback, reg)) {
				return undefined;
			} else {
				return msg;
			}
		}
	};
	return {
		trigger: type,
		validator: customFunc,
	};
};
const telFunc = (val, reg) => {
	if (Array.isArray(val)) {
		let value = `${val[0]}-${val[1]}`;
		if (validRegExp(value, reg)) {
			return true;
		}
	}
	return false;
};
const validRangeNum = (val, reg) => {
	if (Array.isArray(val)) {
		if (validRegExp(val[0], reg) && validRegExp(val[1], reg)) {
			return true;
		}
	}
	return false;
};
const validRangeMix = (val, reg) => {
	if (Array.isArray(val)) {
		if (validRegExp(val[0], reg[0]) && validRegExp(val[1], reg[1])) {
			return true;
		}
	}
	return false;
};

const validTwoArray = val => {
	if (Array.isArray(val)) {
		if (val[0] && val[1]) {
			return true;
		}
	}
	return false;
};

export function validRequired(msg = '此项必填', type = 'blur', dataType) {
	// 必填
	return {
		required: true,
		message: msg,
		trigger: type,
		type: dataType,
	};
}

export function requiredCustom(msg = '此项必填', type = 'blur', dataType) {
	// 必填
	return {
		required: true,
		message: msg,
		trigger: type,
		type: dataType,
		validator: (rule, vaild, value) => {
			if (vaild && Object.keys(vaild).length) {
				return value();
			} else {
				return value(new Error(msg));
			}
		},
	};
}

export function validRequired_copy(msg = '此项必填', type = 'blur', dataType) {
	// 必填
	return {
		required: true,
		message: msg,
		trigger: type,
		type: dataType,
		validator: (rule, valid, value) => {
			if (typeof value === 'function') {
				if (!valid || (Array.isArray(valid) && valid.length === 0)) {
					if (valid === 0) {
						value();
					} else {
						value(new Error(msg));
					}
				} else {
					value();
				}
			} else {
				if (typeof value == 'number') {
					if (value === 0) return undefined;
					return value ? undefined : msg;
				} else if (Array.isArray(value)) {
					return value && value.length ? undefined : msg;
				} else if (Object.prototype.toString.call(value) === '[object Object]') {
					return value && !objJudge(value) ? undefined : msg;
				} else {
					return value && value.length ? undefined : msg;
				}
			}
		},
	};
}

export function validMin(min, msg = `输入的字符不能少于${min}`, type = 'blur') {
	// 最小
	return {
		min: min,
		message: msg,
		trigger: type,
	};
}

export function validMax(max, msg = `输入的字符不能多于${max}`, type = 'blur') {
	// 最大
	return {
		max: max,
		message: msg,
		trigger: type,
	};
}

export function validRange(min, max, msg = `输入的字符需要在${min}到${max}之间`, type = 'change') {
	// 范围
	return {
		min: min,
		max: max,
		message: msg,
		trigger: type,
	};
}

export function oneHundred(msg = '请输入0~100内整数') {
	return customValid(validRegExp, msg, hundred);
}
export function oneHundredDecimal(msg = '请输入0~100内数值') {
	return customValid(validRegExp, msg, hundredDecimal);
}

export function validNum(msg = '请输入数字类型的格式') {
	// 数字格式
	return customValid(validRegExp, msg, num);
}

export function validInt(msg = '请输入整数') {
	// 整数格式
	return customValid(validRegExp, msg, int);
}

export function validMoney(msg = '请输入金额') {
	// 金额
	return customValid(validRegExp, msg, money);
}

export function validDate(msg = '请输入正确的日期格式') {
	// 日期
	return customValid(validRegExp, msg, date);
}

export function validEmail(msg = '请输入正确的邮箱') {
	// 邮箱
	return customValid(validRegExp, msg, email);
}

export function validCharacter(msg = '不能包含特殊字符') {
	// 特殊字符
	return customValid(validRegExp, msg, character);
}
export function validIdCard(msg = '请输入正确的身份证号码') {
	// 身份证
	return customValid(validId, msg);
}

export function validMobile(msg = '请输入正确的手机号') {
	// 手机号
	return customValid(validRegExp, msg, mobile);
}
export function validUrl(msg = '请输入正确的网址') {
	// url
	return customValid(validRegExp, msg, url);
}
export function validUrlRoot(msg = '请输入正确的根域名') {
	// 根域验证
	return customValid(validRegExp, msg, url_root);
}
export function validTel(msg = '请输入正确的固定电话') {
	// 固话
	// return customValid(validRegExp,msg,tel)
	return customValid(telFunc, msg, tel);
}

export function validRangeType(msg = '请输入正确的消耗区间', dataType = 'number') {
	return customValid(validRangeNum, msg, money);
}

export function validRangeNumMoney(msg = '请输入正确的格式') {
	return customValid(validRangeMix, msg, [int, money]);
}

export function validRangeDate(msg = '请选择范围时间') {
	return customValid(validTwoArray, msg, '', 'change');
}
